import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    toggle(event) {
        const checked = event.target.checked;
        this.yearTarget.disabled = checked;
        this.yearTarget.required = !checked;
        if (checked) {
            this.yearTarget.value = "";
        }
    }
}
default_1.targets = ["year"];
export default default_1;
